export const getTableDataForLoading = (pageSize: number, pageIndex: number, totalItems: number) => {
    const createEmptyRows = (count: number) => Array.from({ length: count }, () => ({}));

    if (totalItems === 0) {
        return createEmptyRows(pageSize);
    }

    const pageItems = (pageIndex + 1) * pageSize;
    if (pageItems > totalItems) {
        return createEmptyRows(pageSize - (pageItems - totalItems));
    }

    return createEmptyRows(pageSize);
};
